import * as TYPES from './types';

const initialState = {
  user: {},
  auth: {},
};

function reducer(state = initialState, action) {
  switch (action.type) {
    case TYPES.SET_USER:
      return {
        ...state,
        user: {...state.user, ...action.payload},
      };
    case TYPES.SET_AUTH:
      return {
        ...state,
        auth: {...state.auth, ...action.payload},
      };
    case TYPES.LOGOUT:
      return {
        ...state,
        auth: {},
        user: {},
      };
    case TYPES.FETCH_USER_INFO:
      return {
        ...state,
        auth: action.payload.auth,
        user: action.payload.user,
      };
    default:
      return state;
  }
}
export default reducer;
